import AddressSelectItem from './AddressSelectItem';

export default AddressSelectItem;
